import { useLocation } from "react-router-dom";
import HeaderMain from "../HeaderMain/HeaderMain";
import HeaderSecondary from "../HeaderSecondary/HeaderSecondary";


const Header = () => {
    const location = useLocation()
    return ( 
        <div>
            {
                location.pathname ==='/'
                ? <HeaderMain/> : <HeaderSecondary/>
            }
        </div>
     );
}
 
export default Header;